import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

export const buildSpecItem = (label: string, value: string, isEmail?: boolean) => {
  return (
    <>
      <Grid item xs={5} sx={{ marginBottom: '6px' }}>
        <Typography color="primary" variant="body1">
          {`${label}:`}
        </Typography>
      </Grid>
      <Grid item xs={7} sx={{ marginBottom: '6px' }}>
        {isEmail ? <a href={`mailto: ${value}`}>{value}</a> : value}
      </Grid>
    </>
  );
};
